import { annualBenefitPlanningApi } from '../../../shared/infra/api/annual-benefit-planning.api'

import type { PolicyDto } from './policy.dto'

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

function parsePolicyPayload(response: unknown): PolicyDto | null {
  if (!isRecord(response) || response.status !== 'ok') {
    return null
  }
  const payload = response.data
  if (!isRecord(payload)) {
    return null
  }
  return payload as PolicyDto
}

// EMS-10557: `oepId` targets one enrollment period; omit it for the default period.
export async function getPolicy(
  customerId: string,
  oepId?: string
): Promise<PolicyDto> {
  const { data } = await annualBenefitPlanningApi.get<unknown>(
    `clients/${encodeURIComponent(customerId)}/policy`,
    oepId ? { params: { oepId } } : undefined
  )
  const parsed = parsePolicyPayload(data)
  if (parsed === null) {
    throw new Error('Invalid policy response')
  }
  return parsed
}

export const policy = {
  get: getPolicy,
}
